import { AxiosResponse } from "axios";
import RequestUtilitario, { BasicQueryType } from "../../../../../Utils/RequisicaoUtilitario";
import Parametro from "../../../../../Models/Financeiro/Faturamento/Imposto/Configuracao/Parametro";
import { useQuery } from "@tanstack/react-query";
import { Axios } from "../../../../Axios";

export function useListar({
    codGrupoTributario,
    codRegimeTributario,
    queryKey,
    ...reset
}: BasicQueryType<AxiosResponse<Parametro[]>, {
    codGrupoTributario:number,
    codRegimeTributario:number,
    ativo?: boolean
}>) {
    const queryString = RequestUtilitario.objectToQueryString({
        codGrupoTributario,
        codRegimeTributario
    });

    return useQuery({
        ...reset,
        queryKey: ["Financeiro.Faturamento.Imposto.Configuracao.Parametro.Listar", `Financeiro.Faturamento.Imposto.Configuracao.Parametro.Listar?${queryString}`],
        queryFn: () => Axios.get<Parametro[]>(`financeiro/faturamento/imposto/configuracao/parametro?${queryString}`),
        select : ({ data }) => {
            return data.map(m => {
                m.dataCriacao = new Date(m.dataCriacao);
                return m;
            });
        },
        staleTime: 1000 * 60 * 30 // query ficará valida por 30 min
    });
}

export default {
    useListar
}